module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-4": "",
      "pb-2": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-4": "",
      "pb-2": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createCatalog
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.createCatalog) + "\n      ")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-1 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.selectedCompany || (_vm.isLocalAdmin && _vm.allCatalogs)) ? _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.showActive ? _vm.activeCatalogs : _vm.allCatalogs,
      "headers": _vm.headers,
      "loading": _vm.loading,
      "pagination": _vm.pagination,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.catalogVersion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.catalogName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDateWithTime(props.item.createdOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "min-width": "340px"
          }
        }, [(props.item.status !== 'active') ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "color": "primary",
            "loading": props.item.activating
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.activateCatalog(props.item)
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.activate))]) : _vm._e(), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editCatalog(props.item.catalogId)
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.copyEdit))]), _vm._v(" "), (_vm.$auth.roles.includes('ROLE_SUN_ADMIN_CATALOG')) ? _c('v-btn', {
          staticClass: "ml-0",
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.pushToCorp(props.item.catalogId)
            }
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$lang.actions.pushToCorp) + "\n              ")]) : _vm._e()], 1)]
      }
    }], null, false, 2674845268)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showActivationModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: (_vm.showActivationModal),
      callback: function($$v) {
        _vm.showActivationModal = $$v
      },
      expression: "showActivationModal"
    }
  }, [_c('activation-modal', {
    attrs: {
      "data": _vm.activationData
    },
    on: {
      "close": function($event) {
        return _vm.closeActivation($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.confirmPushModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.confirmPushModal),
      callback: function($$v) {
        _vm.confirmPushModal = $$v
      },
      expression: "confirmPushModal"
    }
  }, [_c('confirm-push', {
    attrs: {
      "id": _vm.catalogId
    },
    on: {
      "close": function($event) {
        _vm.confirmPushModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab50c83a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalog/List.vue
// module id = 428
// module chunks = 35